import React from 'react';
import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import clsx from 'clsx';

import { A11y, Pagination, Swiper, SwiperSlide } from '@common/carousel/swiper';
import {
  HorizontalProductCardListContainer,
  UxGoodsCardItemForVerticalProductCard as UxGoodsCardItem,
} from '@common/product-card';
import { PDPGoodsGroup_goods_carousel_component_list as ProductItemType } from '@domains/pdp-common';

import { PAGE_VIEW_COUNT } from '../../../related-stylist-list/services/useRelatedStylistListService';

interface Props {
  title?: string;
  list: ProductItemType[][];
  onImpressionProduct: (item: UxGoodsCardItem, position: number) => void | Promise<void>;
  onClickProduct: (item: UxGoodsCardItem, position: number) => void | Promise<void>;
  onSaveProduct: (checked: boolean, item: UxGoodsCardItem, position: number) => void | Promise<void>;
}

export const HorizontalProductCarousels = ({
  title,
  list,
  onImpressionProduct,
  onClickProduct,
  onSaveProduct,
}: Props) => {
  return (
    <div css={carouselWrapperCss}>
      {title && (
        <Text
          variant='Body_18_SemiBold'
          color='gray950'
          style={{ padding: 16, whiteSpace: 'break-spaces', lineHeight: '25px' }}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      <Swiper
        className={clsx([list.length === 1 && 'is_single_list'])}
        slidesPerView='auto'
        spaceBetween={16}
        slidesOffsetBefore={16}
        slidesOffsetAfter={50}
        modules={[Pagination, A11y]}
        pagination={list.length > 1}
        role='region'
        aria-roledescription='carousel'
        threshold={20}
      >
        {list.map((items, listIndex) => (
          <SwiperSlide key={listIndex}>
            <HorizontalProductCardListContainer<UxGoodsCardItem>
              css={listContainerCss}
              likeButtonType='thumbnail'
              thumbnailWidth={80}
              badgeHeight={11}
              items={items}
              onImpression={(item, index) => onImpressionProduct(item, listIndex * PAGE_VIEW_COUNT + index)}
              onClick={(item, index) => onClickProduct(item, listIndex * PAGE_VIEW_COUNT + index)}
              onLikeClick={(isLiked, item, index) => onSaveProduct(isLiked, item, listIndex * PAGE_VIEW_COUNT + index)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const carouselWrapperCss = css`
  padding-bottom: 34px;

  .swiper {
    width: 100%;
    height: 100%;

    .swiper-pagination {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      bottom: -14px;
    }

    .swiper-slide {
      width: calc(100% - 66px);
      height: auto;
    }

    .swiper-pagination-bullets {
      .swiper-pagination-bullets {
        bottom: 0;
        height: 22px;
      }

      .swiper-pagination-bullet {
        width: 6px;
        height: 6px;
        opacity: 1;
        background: ${vars.v3Color.gray300};
      }

      .swiper-pagination-bullet-active {
        background: ${vars.v3Color.gray900};
      }
    }

    .swiper-wrapper {
      box-sizing: border-box;
    }
  }

  .swiper:not(.is_single_list) {
    padding-bottom: 22px; // bullets 높이 만큼 지정
  }

  .swiper.is_single_list .swiper-slide {
    width: calc(100% - 32px);
  }
`;

const listContainerCss = css`
  margin: 0;
`;
